import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { nextIterationAsync } from "./_nextIterationAsync.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const minAsync = async (source, selector) => {
    const dataFunc = nextIterationAsync(source, selector);
    const maxInfo = await typeDataToArray(dataFunc);
    if (maxInfo.length === 0) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    return Math.min.apply(null, maxInfo);
};
